export default {
  title:'Top 1 NIKKE Costume Poll',
  time:'2023/06/29 12:00-2023/07/05 23:59 (UTC+9)',
  curp:'Popularity',
  bottips:'The total popularity votes will be updated at 18:00 (UTC+9) every day.',
  toptips:'The costume images are only conceptual sketches under development. <br>The final appearances and effects may differ.',
  dvotet:'Please confirm your vote.',
  dvotep:'No changes can be made after you select Confirm.',
  cancel:'Cancel',
  confirm:'Confirm',
  dloginp:'You can get <strong>1 Recruit Voucher</strong><br> when you access the game for the<br> first time and proceed with costume voting.',
  password:'Password',
  login:'Log In',
  register:'Download & Register',
  logintips:'*Please register account in the game',
  forgetPassword:'forget  password',
  logint:'Please confirm your <br> nickname',
  server:'Server',
  nickname:'Nickname',
  logintip2:'*Each  account  can  only  be  bound  to one  Nickname  to  vote  and to  receive  rewards',
  rulet:'Rules',
  rp1:'Event Introduction<br>Event Period: 12:00, June 29, 2023 to 23:59, July 5, 2023 (UTC+9)<br>Players can vote for their favorite Modernia costumes during the event. The costume with the most votes at the end of the event will be distributed to all players for free!<br>*Please refer to official notices for the release date.',
  rp2:'How to Participate:<br>Players can cast 1 vote for the costume they like during the event. Note that votes submitted cannot be changed.',
  rp3:'Rewards<br>1. Players can claim 1 Recruit Voucher after voting for the costume. Please claim your rewards in your in-game mailbox.<br>2. Share your vote on the designated social media to claim 1 Recruit Voucher. Every player is only entitled to 1 Recruit Voucher. Please check your rewards in your in-game mailbox.',
  rp4:'Notes<br>1. Costume images are conceptual sketches under development. The final appearances and effects may differ.<br>2. Please log in to your game account to take part in the event. To ensure the smooth distribution and collection of rewards, each account can only be linked to 1 server and character.<br>3. The poll results will be updated daily at 18:00 (UTC+9).<br>4. In-game rewards obtained from completing the event tasks will be sent to your mailbox. Please note that there may be system delays. The mail will be valid for 30 days. Do keep an eye out and claim your rewards in time.<br>',
  rp5:'The result of the vote will be published on this page at 18:00 on July 6 (UTC+9).  ',
  votebtn:'vote',
  surepara:'Please note that by accessing the voting portal, we will need to collect your login details, user ID, relevant server, nickname and your votes ("Participation Data") – your votes will not be linked directly to you and are recorded in statistical aggregate. Your Participation Data will be stored on our Singapore server for 6 months, after which it will be deleted. For detailed information on how we process your personal information, please refer to our <a href="https://nikke-en.com/privacypolicy" target="blank" class="dicon5" title="">Privacy Policy.</a>',
  plan1:'-Plan A-',
  plan2:'-Plan B-',
  plan3:'-Plan C-',
  please_select: 'โปรดเลือก',
  submitted_vote: 'You have submitted your vote. You cannot vote again.',
  nv_vote_p: 'The most popular costume will be distributed for free!',

  share_failed: 'แชร์ไม่สำเร็จ',
  no_role_found: 'ไม่พบตัวละคร',
  third_auth_failed: 'การล็อกอินของบุคคลที่สามล้มเหลว กรุณาลองอีกครั้ง',
  pls_input_info: 'กรุณาป้อนข้อมูลล็อกอินของคุณ',

  account_not_exist: 'ไม่พบบัญชี กรุณาลงทะเบียนบัญชีในเกม',
  password_empty: 'บัญชีไม่มีรหัสผ่าน',
  password_not_set: 'กรุณาป้อนข้อมูลล็อกอินของคุณ',

  networkError: 'ข้อผิดพลาดของเครือข่าย',
  serverError: 'เซิร์ฟเวอร์ล้มเหลว',

  shareContent: `สวัสดีปีใหม่กับสการ์เล็ตและ #NIKKE!
  
  ฉันได้พบกับตอนจบสุดพิเศษในอีเวนต์ "New Year Call with Scarlet"! คุณก็ลองมารับสายสิ มาโทรคุยกับสการ์เล็ตเลย! (สปอย: มีรางวัลซ่อนอยู่) มาเริ่มปีใหม่ด้วยกันนะ!
  `,
  laodingPic: "กำลังสร้างภาพ...",
  pleaseLogIn: 'กรุณาล็อกอินก่อน',
  
  BaseSystemError: 'ระบบลงคะแนนล้มเหลว',
  VoteDelNumNotEnough: 'คะแนนโหวตไม่เพียงพอ',
  GetRoleInfoAccountTypeErr: 'ข้อผิดพลาดของประเภทบัญชี',
  RoleInfoNotSaved: 'ไม่ได้บันทึกตัวละคร',
  NoRoleInfo: 'ไม่พบข้อมูลตัวละคร',
  RoleInfoHasSaved: 'บันทึกข้อมูลตัวละครแล้ว',
  FlowHasNotBegin: 'อีเวนต์ยังไม่ได้เริ่มต้นขึ้น',
  FlowHasEnd: 'อีเวนต์ได้จบลงแล้ว',
  MiddlewareFlowLock: 'รีเฟรชเร็วเกินไป โปรดลองอีกครั้งในภายหลัง',
  SignedDayNotEnough: 'วันนี้คุณได้ปลดล็อคนิกเกะไปแล้ว โปรดลองอีกครั้งในวันพรุ่งนี้',
  HasSignedToday: 'เสร็จสิ้นการล็อกอินในวันนี้',
  GetGiftLimit: 'ถึงขีดจำกัดการขอรับแพ็กเกจแล้ว',
  loading: 'กำลังโหลด....',
  open_in_browser: 'กรุณาเปิดในเบราว์เซอร์อื่น',

  logout: 'ล็อกเอาท์',
  privacy:'นโยบายความเป็นส่วนตัว',
  cookies:'นโยบายคุกกี้',
  privacyLink:'https://nikke-sea.com/privacypolicy/',
  cookiesLink:'https://nikke-sea.com/cookiepolicy/',

  claimable: 'รับได้',
  claimed: 'รับแล้ว',
  claimSucess: 'รับแล้ว',

  elysion: 'เอลิเชียน',
  pilgrim: 'พิลกริม',
  tetra: 'เตตร้า',
  missilis: 'มิสสิลิส',
}